import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const ClaimsAdmin = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = ["Select Status", "Cancellation", "Debt collection initiated", "Completed", "Court dunning procedure", "Foreclosures", "Installment payment", "Resubmissions", "Paid" , ];

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
